import { useEffect, useState } from "react";
import { Star, Leaf, Menu, X } from "lucide-react";

const links = [
  { label: "Expertises", href: "#expertises" },
  { label: "Avis Google", href: "#avis" },
  { label: "Réalisations", href: "#realisations" },
  { label: "Contact", href: "#contact" },
];

export const HeaderNav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="header-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow] duration-500 ${
        scrolled
          ? "bg-[#121F17]/90 backdrop-blur-xl shadow-[0_1px_0_rgba(245,243,238,0.08)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <span className="w-9 h-9 rounded-full bg-[#2D5A3F] flex items-center justify-center transition-transform duration-500 group-hover:rotate-[20deg]">
            <Leaf className="w-5 h-5 text-[#F5F3EE]" strokeWidth={1.8} />
          </span>
          <span className="font-serif-rb text-lg tracking-wide text-[#F5F3EE]">
            RB <span className="italic text-[#8CA893]">Espace Vert</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8" data-testid="nav-links">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className="text-sm text-[#F5F3EE]/70 hover:text-[#F5F3EE] transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </a>
          ))}
          <span
            data-testid="nav-google-badge"
            className="hidden lg:flex items-center gap-1.5 text-xs text-[#F5F3EE]/80 border border-[#F5F3EE]/15 rounded-full px-3 py-1.5"
          >
            <Star className="w-3.5 h-3.5 fill-[#D4AF37] text-[#D4AF37]" /> 4,5 sur Google
          </span>
          <a
            href="#contact"
            data-testid="nav-cta-devis"
            className="text-sm font-semibold bg-[#F5F3EE] text-[#121F17] rounded-full px-5 py-2.5 hover:bg-[#D4AF37] hover:text-[#121F17] transition-colors duration-300"
          >
            Devis Gratuit
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-[#F5F3EE] p-2"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#121F17]/95 backdrop-blur-xl border-t border-[#F5F3EE]/10" data-testid="nav-mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/ /g, "-")}`}
                className="text-[#F5F3EE]/80 text-base"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta-devis"
              className="text-center font-semibold bg-[#F5F3EE] text-[#121F17] rounded-full px-5 py-3"
            >
              Devis Gratuit
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
